const tab = {
    SCHOOL: 'SCHOOL',
    ROOM: 'ROOM'
}

export default tab



// WEBPACK FOOTER //
// ./src/edit/Tabs.js